import { type ReactNode } from 'react';

import { AllContentPage } from '~/components/AllContent/AllContentPage';
import { WorkspaceCreateButton } from '~/components/AllContent/WorkspaceCreateButton';
import { getLayout as getHomeLayout } from '~/components/Layouts/HomeLayout/HomeLayout';
import { PrivatePageSearch } from '~/components/Search/PrivatePageSearch';
import { SearchPage } from '~/components/v2/components/search/SearchPage';
import { WorkspacePageBottombar } from '~/components/v2/components/workspace/WorkspacePageBottombar';
import { useShowUI2Page } from '~/components/v2/hooks/useShowUI2Page';
import { PrivatePageLayout } from '~/components/v2/layouts/PrivatePageLayout';

export default function AllPage({ children }: { children?: ReactNode }) {
  const { showUI2 } = useShowUI2Page();

  if (showUI2) {
    return (
      <PrivatePageLayout>
        <SearchPage>{children}</SearchPage>
      </PrivatePageLayout>
    );
  }

  return <AllContentPage>{children}</AllContentPage>;
}

AllPage.getLayout = (page: ReactNode) =>
  getHomeLayout(page, {
    bottomBar: <WorkspacePageBottombar />,
    search: (
      <PrivatePageSearch
        trackLocation="all"
        placeholder="Search all assets & files"
        hideFilterBar={true}
        defaultOpen={false}
      />
    ),
    supportsSmartSearch: true,
    headerActions: <WorkspaceCreateButton />,
  });

export const getLayout = (page: ReactNode) => {
  return getHomeLayout(<AllPage>{page}</AllPage>, { headerActions: <WorkspaceCreateButton /> });
};
